import { render, staticRenderFns } from "./refresh.vue?vue&type=template&id=10dec562&scoped=true&"
import script from "./refresh.vue?vue&type=script&lang=js&"
export * from "./refresh.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10dec562",
  null
  
)

export default component.exports